import React,{ useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';
import Tab from '../../components/Layout/Tab/Tab';
const YouTubeChannel = () => {
    const [videos, setVideos] = useState([]);
	const [shorts, setShorts] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
	const tabRoute = useLocation();
	const [currentTab, setCurrentTab] = useState("#tab1");
	const youTubeTabs = [{
          "name":"Videos",
          "navUrl":"#tab1",
          "iconUrl":""
      },
      {
          "name":"Shorts",
          "navUrl":"#tab2",
          "iconUrl":""
      }]
    useEffect(() => {
        const fetchVideos = async () => {
        const youTubeConfigUrl = process.env.REACT_APP_YOUTUBEVIDEO_URL;
        try {            
            // Fetch videos from uploads playlist
            const videosRes = await axios.get(`${youTubeConfigUrl}`).then((data) => {
              if(data.data.statusCode == 200){
                const parseData = JSON.parse(data.data.body); 
                const videosData = JSON.parse(parseData.data);
                setVideos(videosData.filter((f:any) => f.VideoType === "Videos"));
				setShorts(videosData.filter((f:any) => f.VideoType === "Shorts"));
              }
            });            
        } catch (error) {
            console.error("Failed to fetch videos", error);
        } finally {
            setLoading(false);
        }
    };

    fetchVideos();
    }, []);
    useEffect(() => {setCurrentTab(tabRoute.hash);},[tabRoute.hash]);
    const PlayYouTubeVideo = (videoId: string) => {
        navigate(`/video-player/${videoId}`);
        //window.location.href = `/video-player${videoId}`;
    }
    return (      
    <div className="container liquid-container">
      <div className="clear spacer10"></div>
      <div className="youtube-channel-banner hidden-xs">
        <img src="../content/img/youtubechannels_banner.jpg" alt="YouTube Banner" style={{width:"100%"}} />
        <hr></hr>
      </div>
      <h1 className="bellSlimBold txtSize32 txtBlack txtSize26-xs youtube-title">YouTube Videos</h1>   
      <div className="clear spacer10"></div>
	  <Tab tabList={youTubeTabs} />
      <div className='clear spacer10'></div>     
       {loading ? (
          <>
            <div id="brf-page-loader" className="loader-fixed bgWhite container-flex-box brf-page-loader">
                <img src="../content/img/loader.gif" />
                <div className="page-loader-msg middle-align-self pad-left-10">Loading data, please wait</div>
            </div>
          </>
        ) : ( 
        <>
		  <div className={`tab-container ${currentTab === '#tab1' ? 'active_tab_container' : ''}`} id='#tab1'>	
		   <div className="youtube-channel-video-list">
			  {videos.map((item:any,index) => {
				  return(
					<div key={index} className="youtube-channel-video-list-item">  
					  <div className="youtube-channel-video-img" onClick={() => PlayYouTubeVideo(item.ItemId)}>            
						  <img
							src={item.ThumbNailUrl}
							alt={item.Title}
						  />
					  </div>
					  <p onClick={() => PlayYouTubeVideo(item.ItemId)} className="youtube-channel-video-txt txtBlack txtSize14" title={item.Title}>{item.Title}</p>              
					</div>
				  )          
				})}
			</div>	
		  </div>	
		  <div className={`tab-container ${currentTab === '#tab2' ? 'active_tab_container' : ''}`} id='#tab2'>
		   <div className="youtube-channel-video-list">
			{shorts.map((item:any,index) => {
				return(
                    <div key={index} className="youtube-channel-video-list-item">  
					  <div className="youtube-channel-video-img" onClick={() => PlayYouTubeVideo(item.ItemId)}>            
						  <img
							src={item.ThumbNailUrl}
							alt={item.Title}
						  />
					  </div>
					  <p onClick={() => PlayYouTubeVideo(item.ItemId)} className="youtube-channel-video-txt txtBlack txtSize14" title={item.Title}>{item.Title}</p>              
					</div>
				);
			 })}
			 </div>
		  </div> 		
          </>
      )}           
    </div>
  );
};

export default YouTubeChannel;